<script setup lang="ts">
import AccountCryptoWallet from '../../AccountCryptoWallet.vue'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import AccountPanelLegalMissingDataAlert from '../AccountPanelLegalMissingDataAlert.vue'
import AccountPanelLegalMissingVerificationAlert from '../AccountPanelLegalMissingVerificationAlert.vue'
import { generateCryptoWalletRequestBody } from '../../../../utilities/account/useCryptoWallet'

const state = useLegalAccountDataState()
</script>

<template>
    <div>
        <AccountPanelLegalMissingDataAlert
            v-if="!state.hasAllRequiredProfileAttributesForInvestment"
            inline
            :description-text="$t('crypto_wallet.complete_data_description_for_crypto_wallet')"
            class="my-9" />
        <AccountPanelLegalMissingVerificationAlert
            v-else-if="!state.legalProfile.kyc_legal"
            inline
            :description-text="$t('crypto_wallet.complete_verification_description_for_crypto_wallet')"
            :title-text="$t('verification.kyc_process')"
            show-button="true"
            class="my-9"></AccountPanelLegalMissingVerificationAlert>
        <AccountCryptoWallet
            v-else
            :request-body="
                generateCryptoWalletRequestBody('legal', state.legalProfile.legal_profile_uid)
            "></AccountCryptoWallet>
    </div>
</template>
